import Icon from 'react-icons-kit';

import { home } from 'react-icons-kit/feather/home';
import { user } from 'react-icons-kit/feather/user';
import { userCheck } from 'react-icons-kit/feather/userCheck';
import { archive } from 'react-icons-kit/feather/archive';
import { clipboard } from 'react-icons-kit/feather/clipboard';
import { messageCircle } from 'react-icons-kit/feather/messageCircle';
import { helpCircle } from 'react-icons-kit/feather/helpCircle';
import { check } from 'react-icons-kit/feather/check';
import { x } from 'react-icons-kit/feather/x';
import { trash2 } from 'react-icons-kit/feather/trash2';
import { thumbsUp } from 'react-icons-kit/feather/thumbsUp';
import { thumbsDown } from 'react-icons-kit/feather/thumbsDown';
import { gitMerge } from 'react-icons-kit/feather/gitMerge';
import { logOut } from 'react-icons-kit/feather/logOut';
import { star } from 'react-icons-kit/feather/star';
import { link } from 'react-icons-kit/feather/link';
import { link2 } from 'react-icons-kit/feather/link2';
import { tag } from 'react-icons-kit/feather/tag';
import { mic } from 'react-icons-kit/feather/mic';

// Export react-icons-kit Icon component as default
export default Icon;

// Export icons so they can be easily changed in a single location if necessary

// Resource types
export const HomeIcon = home;
export const UserIcon = user;
export const UserCheckIcon = userCheck;
export const ArchiveIcon = archive;
export const ClipboardIcon = clipboard;
export const ChatIcon = messageCircle;
export const QuoteIcon = helpCircle;
export const CheckIcon = check;
export const CloseIcon = x;
export const StarIcon = star;
export const ThrashIcon = trash2;
export const ThumbsUpIcon = thumbsUp;
export const ThumbsDownIcon = thumbsDown;
export const GitMergeIcon = gitMerge;
export const LinkIcon = link;
export const LogoutIcon = logOut;
export const TagIcon = tag;
export const MicIcon = mic;
